import { useConnectionsRealtime, useReceivedConnectionRequests } from "@/hooks/useCommunityConnections";
import { ReceivedRequestsList } from "./ReceivedRequestsList";
import { SentRequestsList } from "./SentRequestsList";
import { UnifiedConnectionsSection } from "./UnifiedConnectionsSection";

export function CommunityConnectionsSection() {
  // Enable real-time updates
  useConnectionsRealtime();
  
  // Check if there are received requests to show them first
  const { data: receivedRequests } = useReceivedConnectionRequests();
  const hasReceivedRequests = (receivedRequests?.length || 0) > 0;

  return (
    <div className="space-y-8">
      {/* Show received requests prominently if there are any */}
      {hasReceivedRequests && (
        <div className="space-y-4">
          <h2 className="text-lg font-semibold">Pending Requests</h2>
          <ReceivedRequestsList />
        </div>
      )}

      {/* Unified Connections Grid with type filtering */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold">My Connections</h2>
        <UnifiedConnectionsSection />
      </div>

      {/* Pending Requests Section - side by side on desktop */}
      <div className="grid gap-4 md:grid-cols-2">
        {/* Show received requests in normal position if none to highlight */}
        {!hasReceivedRequests && <ReceivedRequestsList />}
        <SentRequestsList />
        {/* Fill space if received is highlighted above */}
        {hasReceivedRequests && <div className="hidden md:block" />}
      </div>
    </div>
  );
}

export default CommunityConnectionsSection;
